"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeItem = void 0;
const react_1 = __importDefault(require("react"));
const TimeItem = ({ time, handleClick }) => {
    const formatTime = (time) => {
        const [hourString, minute] = time.split("T")[1].split("-")[0].split(":");
        const hour = parseInt(hourString) % 24;
        return (hour % 12 || 12) + ":" + minute + (hour < 12 ? " AM" : " PM");
    };
    const timeString = formatTime(time);
    return (react_1.default.createElement("li", { "data-testid": 'time-item', className: "appointment-time-item", onClick: () => handleClick(time, timeString) }, timeString));
};
exports.TimeItem = TimeItem;
